import React, { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { Box } from '@mui/material';
import { poiState } from '@/components/Analysis/modules/pointOfInterest';
import { PageLoader } from '@/components/shared/PageLoader';

export const EquipmentsContainer = ({
  children,
  loading = false,
}: {
  children: React.ReactNode;
  loading: boolean;
}) => {
  const setSelectedPointOfInterestId = useSetAtom(poiState.selectedPointOfInterestId);

  useEffect(() => {
    setSelectedPointOfInterestId(undefined);
  }, [setSelectedPointOfInterestId]);

  return (
    <>
      <div style={{ display: loading ? 'none' : 'block', paddingBottom: '32px' }}>{children}</div>
      {loading && (
        <Box sx={{ position: 'relative', top: '58px' }}>
          <PageLoader />
        </Box>
      )}
    </>
  );
};
